import React from 'react'
import classNames from 'classnames'
import { Grid, GridItem } from '@deal/components'
import { DepartmentNavigationLinkFragment } from '#src/components/Header/NavHierarchyFragments.generated'
import { useNavigationContext } from '#src/components/Header/StandardHeader/NavigationContext'
import objectHash from 'object-hash'
import MenuHeader from '../MenuHeader'
import styles from './styles.css'

interface ActiveTertiaryItemsMenuProps {
  onNavItemSelected: (link: DepartmentNavigationLinkFragment) => void
}

const ActiveTertiaryItemsMenu: React.FC<ActiveTertiaryItemsMenuProps> = ({ onNavItemSelected }) => {
  const navContext = useNavigationContext()

  const activeTertiaryItems = navContext?.activeTertiaryItems

  return (
    <div
      className={classNames(styles.menu, {
        [styles.visible]: !!navContext?.activeSubSection
      })}
    >
      <Grid>
        <GridItem col={2}>
          <MenuHeader
            onBack={() => {
              navContext?.onSetActiveSubSection(null)
            }}
            header={navContext?.activeSubSection?.title}
          />

          <ul className={styles.list}>
            {activeTertiaryItems &&
              activeTertiaryItems.map(tertiaryItem => {
                return (
                  <li
                    key={objectHash(`mobile${tertiaryItem.id}`)}
                    className={styles.listItem}
                    onClick={() => {
                      onNavItemSelected(tertiaryItem.link)
                    }}
                  >
                    <span className={styles.listItemContents}>
                      <span className={styles.listItemLabel}>{tertiaryItem.label}</span>
                    </span>
                  </li>
                )
              })}
          </ul>
        </GridItem>
      </Grid>
    </div>
  )
}

export default ActiveTertiaryItemsMenu
